import { usePermissions } from '@hooks/usePermissions';
import { AlertCircle } from 'lucide-react';
import Card from '@components/common/Card';

const PermissionGuard = ({ 
  permission, 
  permissions, 
  requireAll = false, 
  fallback, 
  children 
}) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissions();

  let hasAccess = false;

  if (permission) {
    hasAccess = hasPermission(permission);
  } else if (permissions && Array.isArray(permissions)) {
    hasAccess = requireAll 
      ? hasAllPermissions(permissions) 
      : hasAnyPermission(permissions);
  } else {
    hasAccess = true;
  }

  if (!hasAccess) {
    if (fallback) {
      return fallback;
    }

    return (
      <Card className="p-12 text-center">
        <AlertCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
        <h3 className="text-xl font-bold text-primary-900 mb-2">Access Denied</h3>
        <p className="text-primary-600">
          You don't have permission to access this feature.
        </p>
      </Card>
    );
  }

  return <>{children}</>;
};

export default PermissionGuard;
